export default __webpack_public_path__ + "static/media/PPI-pools-034.7577616a.jpg";